<template>
	<div class="mb-4 row">
		<div class="col-12 col-md-6 mt-4">
			<h2 v-if="notice.address">{{ notice.address }}</h2>
			<h3>{{ notice.notice_type }}: {{ notice.notice_id }}</h3>
            <p v-if="notice.plain_language"><strong>{{$t('plain_language')}}</strong>: {{notice.plain_language}}</p>
			<ul class="list-unstyled">
				<li v-if="notice.community"><strong>{{ $t('community') }}</strong>: {{ notice.community }}</li>
				<li v-if="notice.neighbourhood"><strong>{{ $t('neighbourhood') }}</strong>: {{ notice.neighbourhood }}</li>
				<li v-if="notice.ward"><strong>{{ $t('ward') }}</strong>: {{ notice.ward }}</li>
				<li v-if="notice.approval_type && !c_type_notice"><strong>{{ $t('approval_type') }}</strong>: {{ notice.approval_type }}</li>
				<li v-if="notice.meeting_date"><strong>{{ $t('meeting_date') }}</strong>: {{ notice.meeting_date | moment('MMMM D, YYYY') }}</li>
				<li v-if="notice.in_date"><strong>{{ $t('in_date') }}</strong>: {{ notice.in_date | moment('MMMM D, YYYY') }}</li>
				<li v-if="notice.order_date"><strong>{{ $t('order_date') }}</strong>: {{ notice.order_date | moment('MMMM D, YYYY')}}</li>
				<li v-if="notice.appeal_date"><strong>{{ $t('appeal_deadline') }}</strong>: {{ notice.appeal_date | moment('MMMM D, YYYY')}}</li>
				<li v-if="notice.decision"><strong>{{ $t('decision') }}</strong>: {{ notice.decision }}</li>
				<li v-if="notice.report_plan_url && c_type_notice"><a :href="notice.report_plan_url.url" target="_blank">{{ $t('view_plans') }}</a></li>
				<li v-else-if="notice.report_plan_url && !c_type_notice"><strong>{{ $t('decision') }}</strong>: <a :href="notice.report_plan_url.url" target="_blank">{{ $t('view_report') }}</a></li>
				<li v-else-if="notice.dmis_decision"><strong>{{ $t('decision') }}</strong>: <a :href="notice.dmis_decision.url" target="_blank">{{ $t('view_dmis') }}</a> {{ $t('view_dmis_delay') }}</li>
			</ul>
			<p v-if="notice.description"><strong>{{ $t('description') }}</strong><span v-for="(description,index) in split_description" :key="index">{{ description }}<br /></span></p>
			<p v-if="notice.conditions"><strong>{{ $t('conditions') }}</strong><span v-for="(condition,index) in split_conditions" :key="index">{{ condition }}<br /></span></p>
			<p v-if="display_appeal_info" v-html="$t('contact_detail')"></p>
			<p v-if="notice.ward || notice.neighbourhood">
				<strong>{{ $t('sign-up-notification') }}</strong>
			</p>
			<div class="row" v-if="notice.ward">
				<div class="col-6 col-md-4">
					<p class="pt-3">{{ $t('ward') }}:</p>
				</div>
				<div class="col-6 col-md-8">
					<button class="btn btn-small btn-secondary m-2" v-if="notice.ward" @click="subscribe_ward">{{ notice.ward }}</button>
				</div>
			</div>
			<div class="row" v-if="notice.neighbourhood">
				<div class="col-6 col-md-4">
					<p class="pt-3">{{ $t('neighbourhood') }}:</p>
				</div>
				<div class="col-6 col-md-8">
					<button class="btn btn-small btn-secondary m-2" v-if="notice.neighbourhood" @click="subscribe_neighbourhood">{{ notice.neighbourhood }}</button>
				</div>
			</div>
		</div>
		<div class="col-12 col-md-6 mt-4">
			<GmapMap :center="centre" :zoom="zoom" style="width: 100%; height: 500px" ref="map" class="box">
				<GmapPolygon :paths="polygon_path" :editable="false">
				</GmapPolygon>
				<GmapMarker
					v-if="marker"
					:position="marker.location"
				></GmapMarker>
			</GmapMap>
		</div>
	</div>
</template>

<script>

import {gmapApi} from 'vue2-google-maps'
import OpenData from '@/libraries/OpenData'

const WINNIPEG_CENTRE = {lat: 49.895495, lng: -97.138465};

export default {
	data() {
		return {
			notice: {},
			notice_id: '',
			notice_type: '',
			notice_identifier: '',
			marker: null,
			centre: WINNIPEG_CENTRE,
			zoom: 14,
			current_marker: {},
			geometry: null,
			polygon_options: {
				strokeColor: "green",
				strokeOpacity: 0.5,
			},
		}
	},

	filters: {
	},

	computed: {

		display_appeal_info() {
			return (this.notice.appeal_date && this.$moment(this.notice.appeal_date).isAfter(new Date));
		},

		c_type_notice() {
			return (this.notice_identifier.toLowerCase() === 'c');
		},

		split_conditions() {
			return this.notice.conditions.split(/\r?\n/);
		},

		split_description() {
			return this.notice.description.split(/\r?\n/);
		},

		parameters() {
			let where_parameters = [
					[ { column: 'notice_type',type: '=',params: [this.notice_type] } ],
					[ { column: 'notice_id',type: '=',params: [this.notice_id] } ]
			];
			return { where_parameters };

		},
		polygon_path() {
			let polygons = [];
			if (this.geometry && this.geometry.the_geom) {
				polygons = this.geometry.the_geom.coordinates.map(entry => {
					return entry.reduce((list,polygon) => {
						return list.concat(polygon.map(point => {
							return {
								lat: parseFloat(point[1]), lng: parseFloat(point[0])
							}
						}))
					}, [])
				})
			}
			return polygons;
		},
	},

	created() {
		const id_parts = this.$route.params.id.split('-');
		this.notice_type = id_parts.shift();
		this.notice_id = id_parts.join('-');
		const ids_identifiers = this.notice_id.split('\/');
		this.notice_identifier = (ids_identifiers.length > 1) ? ids_identifiers[1] : '';
		this.fetch();
	},

	methods: {
		async get_geometry() {
			if (this.notice.roll_number) {
				const roll_number = (this.notice.roll_number.length < 11) ? "0" + this.notice.roll_number : "" + this.notice.roll_number;
				let where_parameters = [ [ { column: 'roll_num',type: '=',params: [roll_number] } ] ];
				const params = { where_parameters };
				const data = await OpenData.getResults(this.$ASSESSMENT_PARCELS_API,params);
				if (data.length) {
					this.geometry = data[0];
					if (!this.notice.location) {
						//for the case of a polygon but no pointer, find the center from the first gps coordinate
						try {
							const first_coord = this.geometry.the_geom.coordinates[0][0][0];
							this.centre = { lat: first_coord[1], lng: first_coord[0] }
							this.zoom = 17;
						} catch(elem) {
							// you tried!
						}
					}
				}
			}
		},

		async fetch() {
			let params = this.parameters;
			const data = await OpenData.getResults(this.$PUBLIC_NOTICES_API,params);
			if (data.length) {
				this.notice = data[0];
				if (this.notice.location && this.notice.location.latitude && this.notice.location.longitude) {
					const marker = {
						location: {
							lat: parseFloat(this.notice.location.latitude),
							lng: parseFloat(this.notice.location.longitude)
						}
					};
					this.centre = marker.location;
					this.marker = marker;
					this.zoom = 17;
				}
				if (this.notice.roll_number) {
					this.get_geometry();
				}
			}
		},

		subscribe_ward() {
			const data = this.encode_subscribe_parameters({ ward: this.notice.ward });
			this.$router.push({name: 'Subscribe', params:{ parameters: data }});
		},

		subscribe_neighbourhood() {
			const data = this.encode_subscribe_parameters({ neighbourhood: this.notice.neighbourhood });
			this.$router.push({name: 'Subscribe', params:{ parameters: data }});
		},
	}
}

</script>

<style>

</style>
